(function(){
  function initSlider(el){
    var range = el.querySelector('[data-range]');
    var before = el.querySelector('[data-clip]');
    var divider = el.querySelector('[data-divider]');
    if(!range || !before || !divider) return;

    function apply(val){
      el.style.setProperty('--cj-compare-pos', val + '%');
    }

    range.addEventListener('input', function(){
      apply(range.value);
    });

    // Keep pointer tracking smooth on touch devices too (range input already
    // handles native touch-drag; this just guards against page-scroll hijack
    // by relying on touch-action: pan-y set in CSS rather than custom JS).
  }

  function init(){
    document.querySelectorAll('cj-compare-slider').forEach(initSlider);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
